import { Component, computed, input, output, viewChild } from '@angular/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { desktopDto } from '@vectronic/desktop-api';

type IdentificationState = {
  deviceId?: number;
  parsedDeviceId?: number;
  state: 'IDENTIFIED' | 'WAITING' | 'NOT_IDENTIFIED';
};

@Component({
  selector: 'table-datatable-rma-device-selector',
  templateUrl: './datatable-rma-device-selector.component.html',
  styleUrls: ['./datatable-rma-device-selector.component.scss'],
  imports: [MatSelectModule],
})
export class DatatableRmaDeviceSelectorComponent {
  identification = input.required<IdentificationState>();
  isComplete = input<boolean>(false);
  disabled = input<boolean>(false);
  connectedDevices = input<desktopDto.DeviceConnection[]>([]);
  identifiedConnection = input<desktopDto.DeviceConnection>();
  disabledDeviceIds = input<number[]>([]);

  selectDevice = output<number | 'MANUAL' | undefined>();

  readonly matSelect = viewChild(MatSelect);

  availableDevices = computed(() => {
    const connections = this.connectedDevices();
    const currentId = this.identification()?.deviceId;
    const items = connections.map((connection) => ({
      deviceId: connection.deviceId,
      connection,
    }));

    if (currentId && !items.some(({ deviceId }) => deviceId === currentId)) {
      items.unshift({ deviceId: currentId, connection: this.identifiedConnection() });
    }

    return items
      .filter(({ deviceId }) => deviceId != null)
      .map(({ deviceId, connection }) => {
        const typeName = connection?.deviceType?.name;
        const connectionType = connection?.type?.includes('BLUETOOTH') ? 'BLE' : connection?.type;

        return {
          deviceId,
          label: [deviceId, typeName, connectionType].filter(Boolean).join(' - '),
          disabled: this.disabledDeviceIds().includes(deviceId),
        };
      });
  });

  onSelect(value: string | number) {
    if (value === 'MANUAL') {
      this.selectDevice.emit('MANUAL');
      setTimeout(() =>
        this.matSelect()?.writeValue(this.identification()?.deviceId ?? 'NOT_IDENTIFIED'),
      );
      return;
    }
    const deviceId = value === 'NOT_IDENTIFIED' || value === '' ? undefined : Number(value);
    this.selectDevice.emit(deviceId);
  }
}
